var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import cloneDeep from 'lodash/cloneDeep';
import constants from './constants';

var CHART_BASE = {
    panning: true,
    pinchType: 'x',
    zoom: 'x',
    style: {
        fontFamily: "'Roboto', sans-serif",
        fontSize: '16px'
    }
};

var THREE_DIMENSIONAL_CHART_BASE = {
    panning: true,
    pinchType: 'x',
    zoom: 'x',
    style: {
        fontFamily: "'Roboto', sans-serif",
        fontSize: '16px'
    },
    options3d: {
        enabled: true,
        alpha: 15,
        beta: 15,
        depth: 50,
        viewDistance: 25,
        axisLabelPosition: 'auto'
    }
};

var SOLIDGAUGECHART_CHART_OPTIONS = {
    type: constants.chartTypes.SOLIDGAUGE
};

var GAUGESERIES_CHART_OPTIONS = {
    type: constants.chartTypes.GAUGE
};

var FUNNEL_CHART_OPTIONS = {
    type: constants.chartTypes.FUNNEL
};

var PYRAMID_CHART_OPTIONS = {
    type: constants.chartTypes.PYRAMID
};

var BULLET_CHART_BASE = {
    inverted: true,
    marginLeft: 100,
    marginRight: 20,
    type: constants.chartTypes.BULLET,
    height: 150
};

var HEATMAP_CHART_OPTIONS = {
    type: constants.chartTypes.HEATMAP,
    marginTop: 40,
    marginBottom: 80,
    plotBorderWidth: 1
};

var RADIALBAR_CHART_OPTIONS = {
    type: constants.chartTypes.COLUMN,
    inverted: true,
    polar: true
};

var configureChart = function configureChart(widgetConfig, customConfig) {
    var GaugeConfig = widgetConfig.GaugeConfig,
        ChartConfig = widgetConfig.ChartConfig,
        XRangeConfig = widgetConfig.XRangeConfig;

    var clonedCustomConfig = cloneDeep(customConfig);

    if (widgetConfig.Type.toLowerCase() === constants.chartTypes.BULLET) return BULLET_CHART_BASE;else if (widgetConfig.Type.toLowerCase() === constants.chartTypes.HEATMAP) return _extends({}, cloneDeep(HEATMAP_CHART_OPTIONS), clonedCustomConfig);

    if (GaugeConfig && GaugeConfig.GaugeType.toLowerCase() === constants.chartTypes.SOLIDGAUGE) return _extends({}, cloneDeep(SOLIDGAUGECHART_CHART_OPTIONS), clonedCustomConfig);else if (GaugeConfig && GaugeConfig.GaugeType.toLowerCase() === constants.chartTypes.GAUGESERIES) return _extends({}, cloneDeep(GAUGESERIES_CHART_OPTIONS), clonedCustomConfig);else if (ChartConfig && ChartConfig.ChartType.toLowerCase() === constants.chartTypes.FUNNEL) return _extends({}, cloneDeep(FUNNEL_CHART_OPTIONS), clonedCustomConfig);else if (ChartConfig && ChartConfig.ChartType.toLowerCase() === constants.chartTypes.PYRAMID) return _extends({}, cloneDeep(PYRAMID_CHART_OPTIONS), clonedCustomConfig);else if (ChartConfig && ChartConfig.ChartType.toLowerCase() === constants.chartTypes.RADIALBAR) return _extends({}, cloneDeep(RADIALBAR_CHART_OPTIONS), clonedCustomConfig);else if (ChartConfig && ChartConfig.ThreeDimensionalView) return _extends({}, cloneDeep(THREE_DIMENSIONAL_CHART_BASE), clonedCustomConfig);
    var config = cloneDeep(CHART_BASE);

    if (XRangeConfig) config.type = 'xrange';

    if (ChartConfig && ChartConfig.ChartType.toLowerCase() === constants.chartTypes.WATERFALL) config.inverted = ChartConfig && ChartConfig.InvertAxes;

    return _extends({}, config, cloneDeep(customConfig));
};

export default configureChart;